import { apiFetch, readErrorMessage, readJson } from '../api/client';

export interface EditorCryptoStatus {
  managedRecoveryAvailable: boolean;
  pbkdf2Iterations: number;
  magic: string;
}

export interface ManagedWrapRequest {
  path: string;
  mountId?: string;
  fileId?: string;
  dataKeyB64: string;
}

export interface ManagedWrapResponse {
  wrappedKeyB64: string;
}

export interface ManagedUnwrapRequest {
  path: string;
  mountId?: string;
  fileId?: string;
  wrappedKeyB64: string;
}

export interface ManagedUnwrapResponse {
  dataKeyB64: string;
}

const STATUS_URL = '/api/editor-crypto/status';
const MANAGED_WRAP_URL = '/api/editor-crypto/managed-wrap';
const MANAGED_UNWRAP_URL = '/api/editor-crypto/managed-unwrap';

export async function fetchEditorCryptoStatus(): Promise<EditorCryptoStatus> {
  const res = await apiFetch(STATUS_URL);
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<EditorCryptoStatus>(res);
}

export async function managedWrapDataKey(
  request: ManagedWrapRequest
): Promise<ManagedWrapResponse> {
  const res = await apiFetch(MANAGED_WRAP_URL, {
    method: 'POST',
    body: JSON.stringify(request)
  });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<ManagedWrapResponse>(res);
}

export async function managedUnwrapDataKey(
  request: ManagedUnwrapRequest
): Promise<ManagedUnwrapResponse> {
  const res = await apiFetch(MANAGED_UNWRAP_URL, {
    method: 'POST',
    body: JSON.stringify(request)
  });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<ManagedUnwrapResponse>(res);
}
